import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common'; // Import isPlatformBrowser
import { CloudFunctionsService } from '../../services/cloud-functions.service';
import { AnalyticsService } from '../../services/analytics.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-redirect',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {
  targetUrl!: string;
  redirectId!: string;
  shopId!: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cloudFunctionsService: CloudFunctionsService,
    private analytics: AnalyticsService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.shopId = environment.shopId || 'defaultShopId';

      this.route.queryParams.subscribe(async params => {
        this.targetUrl = params['url'] || `https://search.google.com/local/writereview?placeid=${this.shopId}`;
        this.redirectId = params['id'] || 'unknown';

        const visitorId = this.getOrCreateVisitorId();
        try {
          const trackingResult = await this.trackRedirect(this.redirectId, visitorId, this.shopId);

          // Analytics Event für Redirect tracken
          this.analytics.trackCustomEvent('redirect_click', {
            eventType: 'click',
            elementId: this.redirectId,
            customData: {
              targetUrl: this.targetUrl,
              redirectType: 'external_redirect'
            },
            isConversion: false
          });

          if (trackingResult.status === 'success') {
            this.routeToURL(this.targetUrl);
          } else {
            this.routeToURL(this.targetUrl);
          }
        } catch (error: any) {
          this.routeToURL(this.targetUrl);
        }
      });
    }
  }


  private routeToURL(url: string): void {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    }
  }

  private getOrCreateVisitorId(): string {
    let visitorId = localStorage.getItem('visitor_id');

    if (!visitorId) {
      visitorId = 'v_' + Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      localStorage.setItem('visitor_id', visitorId);
    }
    return visitorId;
  }

  private async trackRedirect(redirectId: string, visitorId: string, shopId: string): Promise<any> {
    return this.cloudFunctionsService.callFunction('track_redirect_event', { shopId, redirectId, visitorId });
  }
}